export const exportCSV = (dados, nomeArquivo = "relatório.csv") => {
  if (!dados || dados.length === 0) return;

  const headers = Object.keys(dados[0]).join(";");

  const linhas = dados.map(obj => Object.values(obj).join(";")).join("\n");

  const csvContent = "\uFEFF" + headers + "\n" + linhas;

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", nomeArquivo);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};